import core from '@gin-betting/core';

const {
    constants: { ROUTE_DIVIDER },
    utils: {
        extractParentRouteFromHistory: extractParentRouteFromHistoryVendor,
    },
} = core;

export default function extractParentRouteFromHistory() {
    const parentRoute = extractParentRouteFromHistoryVendor();

    if (parentRoute === ROUTE_DIVIDER) return '';

    return parentRoute;
}
